

import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { InfoDatosContainerModel } from '../../store/info-datos.model';
import { InfoDatosBdContainerActions as ContainerActions } from '../../store/info-datos.actions';
import { INFO_DATOS_BD_STATE_TOKEN as CONTAINER_STATE_TOKEN } from '../../store/states/info-datos.state';
import { DialogService } from 'shared';
import { ModalSolicitudApiComponent } from 'src/app/core/components/modals/modal-solicitud-api/modal-solicitud-api.component';
import { ModalBuscaKeyComponent } from 'src/app/core/components/modals/modal-busca-key/modal-busca-key.component';
import { ModalEncuestaApiComponent } from 'src/app/core/components/modals/modal-encuesta-api/modal-encuesta-api.component';
import { ModalManualApiComponent } from 'src/app/core/components/modals/modal-manual-api/modal-manual-api.component';
import { catchError } from 'rxjs/operators';
import { DatosService } from 'src/app/modules/datos/services/datos.service';
import { ArchivoService, PeriodoAcademicoromanoEnum } from '@app/core';
import { environment } from 'src/environments/environment';

const TIPOS_PERIODOS_ALL = [
  {
    name: PeriodoAcademicoromanoEnum.PERIODO_2020,
    label: PeriodoAcademicoromanoEnum.PERIODO_2020
  },
  {
    name: PeriodoAcademicoromanoEnum.PERIODO_2021,
    label: PeriodoAcademicoromanoEnum.PERIODO_2021
  },
  {
    name: PeriodoAcademicoromanoEnum.PERIODO_2022,
    label: PeriodoAcademicoromanoEnum.PERIODO_2022
  },
  {
    name: PeriodoAcademicoromanoEnum.PERIODO_2023,
    label: PeriodoAcademicoromanoEnum.PERIODO_2023
  },
  {
    name: PeriodoAcademicoromanoEnum.PERIODO_2024,
    label: PeriodoAcademicoromanoEnum.PERIODO_2024
  },
  {
    name: PeriodoAcademicoromanoEnum.PERIODO_2020_1,
    label: PeriodoAcademicoromanoEnum.PERIODO_2020_1
  },
  {
    name: PeriodoAcademicoromanoEnum.PERIODO_2020_2,
    label: PeriodoAcademicoromanoEnum.PERIODO_2020_2
  },
  {
    name: PeriodoAcademicoromanoEnum.PERIODO_2021_1,
    label: PeriodoAcademicoromanoEnum.PERIODO_2021_1
  },
  {
    name: PeriodoAcademicoromanoEnum.PERIODO_2021_2,
    label: PeriodoAcademicoromanoEnum.PERIODO_2021_2
  },
  {
    name: PeriodoAcademicoromanoEnum.PERIODO_2022_1,
    label: PeriodoAcademicoromanoEnum.PERIODO_2022_1
  },
  {
    name: PeriodoAcademicoromanoEnum.PERIODO_2022_2,
    label: PeriodoAcademicoromanoEnum.PERIODO_2022_2
  },
  {
    name: PeriodoAcademicoromanoEnum.PERIODO_2023_1,
    label: PeriodoAcademicoromanoEnum.PERIODO_2023_1
  },
  {
    name: PeriodoAcademicoromanoEnum.PERIODO_2023_2,
    label: PeriodoAcademicoromanoEnum.PERIODO_2023_2
  },
  {
    name: PeriodoAcademicoromanoEnum.PERIODO_2024_1,
    label: PeriodoAcademicoromanoEnum.PERIODO_2024_1
  },
  {
    name: PeriodoAcademicoromanoEnum.PERIODO_2024_2,
    label: PeriodoAcademicoromanoEnum.PERIODO_2024_2
  }
];

@Component({
  selector: 'app-tab-informacion',
  templateUrl: './tab-informacion.component.html',
  styleUrls: ['./tab-informacion.component.scss']
})
export class TabInformacionComponent implements OnInit {

  @Select(CONTAINER_STATE_TOKEN) state$: Observable<InfoDatosContainerModel>;

  form: FormGroup;

  databaseDownload: any = {};
  downloaded = [];
  itemSelectedHover = null;
  state = '';
  varAnioCurso: string = environment.anioCurso;
  
  tiposInformacion = [
    {
      name: 'TODOS',
      label: 'Todos'
    },
    {
      name: 'DOCENTE',
      label: 'Docentes'
    },
    {
      name: 'INGRESOS',
      label: 'Ingresantes'
    },
    {
      name: 'MATRICULA',
      label: 'Matriculados'
    },
    {
      name: 'INSTITUCIONAL',
      label: 'Oferta universitaria'
    },
    {
      name: 'POSTULANTE',
      label: 'Postulantes'
    }
  ]

  tiposPeriodos = [
    ...TIPOS_PERIODOS_ALL
  ];

  solicitaApiButton = {
    src: '/assets/img/api/btn_solcita-key.png',
    srcOn: '/assets/img/api/btn_solcita-key_hover.png',
    srcOut: '/assets/img/api/btn_solcita-key.png'
  };

  buscaApiButton = {
    src: '/assets/img/api/btn_busca-key.png',
    srcOn: '/assets/img/api/btn_busca-key_hover.png',
    srcOut: '/assets/img/api/btn_busca-key.png'
  };

  encuestaApiButton = {
    src: '/assets/img/api/btn_encuesta.png',
    srcOn: '/assets/img/api/btn_encuesta_hover.png',
    srcOut: '/assets/img/api/btn_encuesta.png'
  };

  manualApiButton = {
    src: '/assets/img/api/btn_manual.png',
    srcOn: '/assets/img/api/btn_manual_hover.png',
    srcOut: '/assets/img/api/btn_manual.png'
  };

  cantidadUniversidades$: Observable<string>;
  fechaCorte$: Observable<string>;

  constructor(
    private store: Store,
    private formBuilder: FormBuilder,
    private dialogService: DialogService,
    private datosService: DatosService,
    private archivoService: ArchivoService
  ) { }

  ngOnInit(): void {
    this.buildForm();
    this.handleSearch()

    this.form.valueChanges.subscribe((value) => {
      this.handleSearch()
    });

    this.form.get('tipoInformacion').valueChanges.subscribe((value) => {
      this.form.get('idPeriodo').setValue(null);
      switch (value) {
        case 'INGRESOS':
          this.tiposPeriodos = [
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2020,
              label: PeriodoAcademicoromanoEnum.PERIODO_2020
            },
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2021,
              label: PeriodoAcademicoromanoEnum.PERIODO_2021
            },
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2022,
              label: PeriodoAcademicoromanoEnum.PERIODO_2022
            },
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2023,
              label: PeriodoAcademicoromanoEnum.PERIODO_2023
            },
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2024,
              label: PeriodoAcademicoromanoEnum.PERIODO_2024
            }
          ];
          break;
        case 'MATRICULA':
          this.tiposPeriodos = [
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2020_1,
              label: PeriodoAcademicoromanoEnum.PERIODO_2020_1
            },
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2020_2,
              label: PeriodoAcademicoromanoEnum.PERIODO_2020_2
            },
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2021_1,
              label: PeriodoAcademicoromanoEnum.PERIODO_2021_1
            },
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2021_2,
              label: PeriodoAcademicoromanoEnum.PERIODO_2021_2
            },
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2022_1,
              label: PeriodoAcademicoromanoEnum.PERIODO_2022_1
            },
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2022_2,
              label: PeriodoAcademicoromanoEnum.PERIODO_2022_2
            },
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2023_1,
              label: PeriodoAcademicoromanoEnum.PERIODO_2023_1
            },
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2023_2,
              label: PeriodoAcademicoromanoEnum.PERIODO_2023_2
            },
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2024_1,
              label: PeriodoAcademicoromanoEnum.PERIODO_2024_1
            },
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2024_2,
              label: PeriodoAcademicoromanoEnum.PERIODO_2024_2
            }
          ];
          break;
        case 'DOCENTE':
          this.tiposPeriodos = [
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2020_1,
              label: PeriodoAcademicoromanoEnum.PERIODO_2020_1
            },
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2020_2,
              label: PeriodoAcademicoromanoEnum.PERIODO_2020_2
            },
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2021_1,
              label: PeriodoAcademicoromanoEnum.PERIODO_2021_1
            },
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2021_2,
              label: PeriodoAcademicoromanoEnum.PERIODO_2021_2
            },
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2022_1,
              label: PeriodoAcademicoromanoEnum.PERIODO_2022_1
            },
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2022_2,
              label: PeriodoAcademicoromanoEnum.PERIODO_2022_2
            },
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2023_1,
              label: PeriodoAcademicoromanoEnum.PERIODO_2023_1
            },
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2023_2,
              label: PeriodoAcademicoromanoEnum.PERIODO_2023_2
            },
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2024_1,
              label: PeriodoAcademicoromanoEnum.PERIODO_2024_1
            },
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2024_2,
              label: PeriodoAcademicoromanoEnum.PERIODO_2024_2
            }
          ];
          break;
        case 'POSTULANTE':
          this.tiposPeriodos = [
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2022,
              label: PeriodoAcademicoromanoEnum.PERIODO_2022
            },
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2023,
              label: PeriodoAcademicoromanoEnum.PERIODO_2023
            },
            {
              name: PeriodoAcademicoromanoEnum.PERIODO_2024,
              label: PeriodoAcademicoromanoEnum.PERIODO_2024
            }
          ];
          break;
        default:
          this.tiposPeriodos = [...TIPOS_PERIODOS_ALL];
          break;
      }
    });

    //this.cantidadUniversidades$ = this.datosService.getCantidadUniversidadesDWH(this.form.get('idPeriodo').value, 'DOCENTE');
    this.cantidadUniversidades$ = this.datosService.getCantidadUniversidadesDWH('2020-1', 'DOCENTE');
    this.fechaCorte$ = this.datosService.getFechaCorte();
  }

  buildForm = () => {
    this.form = this.formBuilder.group({
      idPeriodo: [null],
      tipoInformacion: [null]
    });
  }

  downloadFormat = async (formato, data) => {
    if (this.state === 'downloading')
      return false;

    this.state = 'downloading';
    this.databaseDownload = {
      tipo: data.categoria,
      periodo: data.periodo,
      id: formato.id,
      formato: formato.formato
    }
    this.store.dispatch(new ContainerActions.AgregarArchivoDescarga({
      item: {
        tipo: data.categoria,
        periodo: data.periodo,
        id: formato.id,
        formato: formato.formato
      }
    }));

    this.datosService.descargarZip(
      [formato.id]
    ).subscribe(
      (data: any) => {
        console.log(data)
        window.open(data.webUrl, '_blank');
        this.state = '';
        this.downloaded.push(formato.id)
        this.databaseDownload = {}
      },
      catchError(() => {
        this.state = ''
        return this.state = '';
        this.databaseDownload = {}
      })
    );
  }

  getIconDownload(formato) {
    let className = 'tuni-icono-lg tuni-icono-' + formato.formato + ' cursor-pointer';
    if (this.downloaded.includes(formato.id))
      className += ' tuni-icono-' + formato.formato + '-downloaded';
    else if (this.itemSelectedHover === formato.id && this.state !== 'downloading')
      className += ' tuni-icono-' + formato.formato + '_hover';
    else
      className += formato.id === this.databaseDownload.id ? ' tuni-icono-' + formato.formato + '-donwloading' : '';

    return [className];
  }

  itemHover(event, add, formato) {
    if (add)
      this.itemSelectedHover = formato.id;
    else
      this.itemSelectedHover = null;
  }

  handleSearch = () => {
    const value = this.form.getRawValue();
    this.store.dispatch([new ContainerActions.SetSearchForm({
      ...value,
      categorias: this.getFilterByCheck()
    }),
    new ContainerActions.ListarBaseDatos(),
    new ContainerActions.getObtenerFechaCorte({ modulo:''}),
    new ContainerActions.getObtenerInstFechaCorte({ modulo:'INSTITUCIONAL'}),
  ]);
  }

  handleSolicitaApi = () => {
    this.dialogService.openMD(ModalSolicitudApiComponent, {
      data: {
      }
    });
  }
  handleBuscaKey = () => {
    this.dialogService.openMD(ModalBuscaKeyComponent, {
      data: {
      }
    });
  }
  handleEncuestaApi = () => {
    this.dialogService.openMD(ModalEncuestaApiComponent, {
      data: {
      }
    });
  }
  handleManualApi = () => {
    this.archivoService.verPdf('manual-api');
  }

  getFilterByCheck() {
    const checkFilter = []
    if (this.form.value.tipoInformacion === 'DOCENTE')
      checkFilter.push('Docente');
    if (this.form.value.tipoInformacion === 'INGRESOS')
      checkFilter.push('Ingresante');
    if (this.form.value.tipoInformacion === 'MATRICULA')
      checkFilter.push('Matriculado');
    if (this.form.value.tipoInformacion === 'INSTITUCIONAL')
      checkFilter.push('Oferta universitaria');
    if (this.form.value.tipoInformacion === 'POSTULANTE')
      checkFilter.push('Postulante');
    return checkFilter
  }

  getIsDownloaded(formatos) {
    return formatos.some(x => x.id === this.databaseDownload.id);
  }

  handleClickDescargarFicha = () => {
    this.archivoService.verPdf(`ficha-tuni-${this.varAnioCurso}`, 'Ficha técnica - Visualizaciones.pdf');
    //this.archivoService.verPdf('ficha-bd', 'Ficha técnica - Base de datos.pdf');
  }


  handleFechaCorte = (fecha) => {
    let fechaCorte = "18 de noviembre.";
    let anioCorte = "2021"
    let dateCorte = new Date(fecha);
    let aCorte = dateCorte.getFullYear();
    let dCorte = dateCorte.getDate();
    let mCorte = dateCorte.getMonth();
    fechaCorte = dCorte + " de " + this.getMesNombre((dateCorte.getMonth() + 1 > 9 ? (dateCorte.getMonth() + 1) : '0' + (dateCorte.getMonth() + 1))) + "."
    anioCorte = aCorte + "";
    return this.getMesNombre((dateCorte.getMonth() + 1 > 9 ? (dateCorte.getMonth() + 1) : '0' + (dateCorte.getMonth() + 1))) + " de " + anioCorte
  }

  getMesNombre = (idx) => {
    var objDate = new Date();
    objDate.setDate(1);
    objDate.setMonth(idx - 1);
    var locale = "es-ES",
      month = objDate.toLocaleString(locale, { month: "long" });
    return month;
  }

}
